import styles from "../../pages/BlogArticle.module.scss";
import { useLanguage } from "../../contexts/LanguageContext";
import { blogText } from "../../i18n/blog";
import { getArticleSections, getSectionId } from "./articleUtils";

export function TableOfContents({ article }) {
  const { lang } = useLanguage();
  const t = blogText[lang] || blogText.JP;
  const sections = getArticleSections(article);

  return (
    <div className={styles.tocBox}>
      <div>
        <h2>{t.tocTitle}</h2>

        <ol>
          {sections.map((section, index) => (
            <li key={section.number || index}>
              <a href={`#${getSectionId(index)}`}>
                {article.toc?.[index] || section.title}
              </a>
            </li>
          ))}
        </ol>
      </div>

      <img
        src={article.tocImage || article.mainImage}
        alt={`${article.title} ${t.tocImageAlt}`}
      />
    </div>
  );
}
